<template>
  <button class="help-center-modal-container"
       ref="help-modal"
       @mousedown="focused"
       :style="{
         width: `${width}px`,
         height: `${height}px`,
         display: state ? 'flex' : 'none',
         'z-index': zIndex,
         top: `${y}px`,
         left: `${x}px`,
       }"
  >
    <div class="help-center-center-header" @mousedown="drag">
      <div class="help-center-title">{{ title }}</div>
      <div class="help-center-buttons">
        <div><a-icon v-if="refreshIcon" type="sync" @click="() => button('refresh')"/></div>
        <div><a-icon :type="iconMinimized" @click="minimize"/></div>
        <div><a-icon v-if="closeIcon" type="close" @click="() => button('close')"/></div>
      </div>
    </div>
    <div class="help-center-content">
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    refreshIcon: {
      type: Boolean,
      default: true,
    },
    closeIcon: {
      type: Boolean,
      default: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
      default: 350,
    },
    height: {
      type: Number,
      default: 600,
    },
    x: {
      type: Number,
      default: 90,
    },
    y: {
      type: Number,
      default: 100,
    },
  },
  data: () => ({
    state: false,
    clientX: undefined,
    clientY: undefined,
    movementX: 0,
    movementY: 0,
    id: Date.now(),
    zIndex: 99,
    minimized: false,
    iconMinimized: 'vertical-align-middle',
  }),
  methods: {
    toggle(value) {
      this.state = typeof value === 'boolean' ? value : !this.state;
      this.focused();
      if (this.minimized) this.minimize();
    },
    button(event) {
      if (event !== 'close') return this.$emit(event);
      this.toggle(false);
      if (this.minimized) this.minimize();
    },
    drag(event) {
      if (!this.draggable) return;
      event.preventDefault();
      this.clientX = event.clientX;
      this.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag(event) {
      event.preventDefault();
      this.movementX = this.clientX - event.clientX;
      this.movementY = this.clientY - event.clientY;
      this.clientX = event.clientX;
      this.clientY = event.clientY;
      // set the element's new position:
      const element = this.$refs['help-modal'];
      const topPosition = element.offsetTop - this.movementY;
      const leftPosition = element.offsetLeft - this.movementX;
      element.style.top = `${topPosition}px`;
      element.style.left = `${leftPosition}px`;
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    focused() {
      this.zIndex = String(Date.now())
        .substr(-7);
    },
    minimize() {
      this.$refs['help-modal'].style.height = this.minimized ? `${this.height}px` : '50px';
      this.minimized = !this.minimized;
      this.iconMinimized = !this.minimized ? 'vertical-align-middle' : 'column-height';
    },
  },
};
</script>

<style>
.help-center-modal-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  background: white;
  border-radius: 5px;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);
  overflow: hidden;
  border: 1px solid rgba(249, 250, 251, 1);
  padding: 0;
  transition: height 0.5s ease;
}

.help-center-center-header {
  width: 100%;
  height: 50px;
  cursor: move;
  display: flex;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid rgba(229, 231, 235, 1);
  justify-content: space-between;
  align-items: center;
}

.help-center-title {
  text-align: left;
  font-size: 1.4rem;
  font-weight: 600;
  flex-grow: 2;
  color: rgba(75, 85, 99, 1);
}

.help-center-buttons {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  color: rgba(107, 114, 128, 1);
}

.help-center-buttons > * {
  cursor: pointer;
  padding: 0 10px;
}

.help-center-buttons > *:last-child {
  padding-right: 0;
}

.help-center-content {
  width: 100%;
  height: calc(100% - 50px);
}
</style>
